import { AxiosConfigExplore } from "Explore/Config/AxiosConfig";

export const getAllInstitutionExplore = (page, rowsPerPage, callback) => {
  const axios = AxiosConfigExplore();
  const url = `/institution/explore?page=${page}&rowsPerPage=${rowsPerPage}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getInstitutionDetailSummaryByID = (id, callback) => {
  const axios = AxiosConfigExplore();
  const url = `/institution/summary?institutionId=${id}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getInstitutionScholarKeywordsByID = (
  id,
  startYear,
  endYear,
  granularityLevel,
  params,
  unit,
  callback
) => {
  const axios = AxiosConfigExplore();
  let url = `/institution/keyword_cloud?institutionId=${id}&fromYear=${startYear}&toYear=${endYear}&granularityLevel=${granularityLevel - 1
    }`;
  if (params) {
    url += `&${params}`;
  }
  if (unit) {
    url += `&unit=${encodeURIComponent(unit)}`;
  }
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getInstitutionPublicationsKeywordsByID = (
  id,
  startYear,
  endYear,
  granularityLevel,
  params,
  callback
) => {
  const axios = AxiosConfigExplore();
  let url = `/institution/publications_keyword_cloud?institutionId=${id}&fromYear=${startYear}&toYear=${endYear}&granularityLevel=${granularityLevel - 1
    }`;
  if (params) {
    url += `&${params}`;
  }
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getInstitutionGrantsKeywordsByID = (
  id,
  startYear,
  endYear,
  granularityLevel,
  params,
  callback
) => {
  const axios = AxiosConfigExplore();
  let url = `/institution/grants_keyword_cloud?institutionId=${id}&fromYear=${startYear}&toYear=${endYear}&granularityLevel=${granularityLevel - 1
    }`;
  if (params) {
    url += `&${params}`;
  }
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getInstitutionScholarsByID = async ({
  id,
  query,
  page,
  rowsPerPage,
  startYear,
  endYear,
  keywords,
  department,
  order_by,
}) => {
  const axios = AxiosConfigExplore();
  let url;
  if (keywords?.length > 0) {
    let params = new URLSearchParams();
    keywords.forEach((keyword) => {
      if (keyword) {
        params.append("keyword", keyword.value);
      }
    });
    url = `/institution/authors?institutionId=${id}&page=${page}&rowsPerPage=${rowsPerPage}&fromYear=${startYear}&toYear=${endYear}&${params.toString()}`;
  } else {
    url = `/institution/authors?institutionId=${id}&page=${page}&rowsPerPage=${rowsPerPage}&fromYear=${startYear}&toYear=${endYear}`;
  }
  if (query) {
    url += `&query=${query?.query || query}`;
  }
  if (department) {
    url = url + `&unit=${encodeURIComponent(department)}`;
  }
  if (order_by) {
    url = url + `&order_by=${order_by}`;
  }
  const res = await axios.get(url);
  return res.data;
};

export const getInstitutionPublicationsByID = async ({
  id,
  unit,
  keywords,
  verified,
  startYear,
  endYear,
  page,
  rowsPerPage,
}) => {
  const axios = AxiosConfigExplore();
  let url = `/institution/publications?institutionId=${id}&`;
  if (keywords.length > 0) {
    let params = new URLSearchParams();
    keywords.forEach((keyword) => {
      if (keyword) {
        params.append("keyword", keyword.value);
      }
    });
    url += `${params.toString()}&`;
  }
  if (unit) {
    url += `unit=${encodeURIComponent(unit)}&`;
  }
  if (verified) {
    url += `verified=${1}&`;
  } else {
    url += `verified=${0}&`;
  }
  if (startYear) {
    url += `fromYear=${startYear}&`;
  }
  if (endYear) {
    url += `toYear=${endYear}&`;
  }
  if (page) {
    url += `page=${page}&`;
  } else {
    url += `page=0&`;
  }
  if (rowsPerPage) {
    url += `rowsPerPage=${rowsPerPage}&`;
  } else {
    url += `rowsPerPage=20`;
  }
  url = url.slice(0, -1);
  const res = await axios.get(url);
  return res.data;
};

export const getInstitutionPeersByID = (
  id,
  page,
  rowsPerPage,
  startYear,
  endYear,
  keywords,
  callback
) => {
  const axios = AxiosConfigExplore();
  let url;
  if (keywords.length > 0) {
    let params = new URLSearchParams();
    keywords.forEach((keyword) => {
      if (keyword) {
        params.append("keyword", keyword.value);
      }
    });
    url = `/institution/peers?institutionId=${id}&page=${page}&rowsPerPage=${rowsPerPage}&fromYear=${startYear}&toYear=${endYear}&${params.toString()}`;
  } else {
    url = `/institution/peers?institutionId=${id}&page=${page}&rowsPerPage=${rowsPerPage}&fromYear=${startYear}&toYear=${endYear}`;
  }
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getSearchInstitutions = (filters, callback, errCallback) => {
  const axios = AxiosConfigExplore();
  let url = `/institution/search`;

  axios
    .post(url, filters)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      errCallback?.(err);
    });
};

// Promise-based variant used by useInfinityPagination (see FacultyList pattern).
// Errors are rethrown so callers can handle 401 (login-required) via errCallback.
export const searchInstitutions = async (data) => {
  const axios = AxiosConfigExplore();
  const url = `/institution/v2/search`;
  const res = await axios.post(url, data);
  return res.data;
};

export const getSuggestSearchInstitutions = (params, callback) => {
  const axios = AxiosConfigExplore();
  const url = `/institution/suggest/${params}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getDepartmentSuggestSearch = (param, callback) => {
  const axios = AxiosConfigExplore();
  const url = `/unit/suggest/${param}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getInstitutionDepartment = (id, callback) => {
  const axios = AxiosConfigExplore();
  const url = `/institution/departments?institutionId=${id}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getInstitutionUnit = (
  institution_id,
  unit_id,
  page,
  pageSize,
  callback
) => {
  const axios = AxiosConfigExplore();
  let params = new URLSearchParams();
  params.append("institutionId", institution_id);
  if (unit_id) {
    params.append("unitId", unit_id);
  }
  params.append("page", page - 1);
  params.append("pageSize", pageSize);

  const url = `/institution/units?${params.toString()}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getInstitutionUnitSearch = (
  institution_id,
  unit_name,
  level,
  page,
  pageSize,
  callback
) => {
  const axios = AxiosConfigExplore();
  let params = new URLSearchParams();
  params.append("institutionId", institution_id);
  if (unit_name) {
    params.append("unit_name", unit_name);
  }
  if (level) {
    params.append("level", level);
  }
  params.append("page", page - 1);
  params.append("pageSize", pageSize);

  const url = `/institution/search_units?${params.toString()}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getInstitutionTopAwardedGrants = async ({
  id,
  unit_name,
  keywords,
  page,
  rowsPerPage,
  fromYear,
  toYear,
  order_by,
  order,
}) => {
  const axios = AxiosConfigExplore();
  let params = new URLSearchParams();
  params.append("institutionId", id);
  if (keywords?.length > 0) {
    keywords.forEach((keyword) => {
      if (keyword) {
        params.append("keyword", keyword.value);
      }
    });
  }
  if (unit_name) {
    params.append("unit", unit_name);
  }
  if (fromYear && toYear) {
    params.append("fromYear", fromYear);
    params.append("toYear", toYear);
  }
  if (!!order_by) params.append("order_by", order_by);
  if (!!order) params.append("order", order);
  params.append("page", page);
  params.append("rowsPerPage", rowsPerPage);

  const url = `/institution/awarded_grants?${params.toString()}`;
  const res = await axios.get(url);
  return res.data;
};

export const getInstitutionTopRankingKeywords = async (args) => {
  const { institution_id } = args;
  const axios = AxiosConfigExplore();
  const url = `/institution/top_ranking_keywords?institutionId=${institution_id}`;
  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getRelatedInstitutionsById = async ({ id }) => {
  const axios = AxiosConfigExplore();
  const url = `/institution/related_institutions?institutionId=${id}`;
  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getInstitutionInternationalCollaboratorsGeneral = async ({
  institutionId,
  keyword = [],
  timeFilter,
}) => {
  const axios = AxiosConfigExplore();
  const searchParams = new URLSearchParams();
  searchParams.append("institutionId", institutionId);
  keyword?.forEach((e) => searchParams.append("keyword", e));
  if (timeFilter) {
    searchParams.append("timeFilter", timeFilter);
  }
  const url = `/institution/international_collaborators/general?${searchParams.toString()}`;
  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getInstitutionInternationalCollaboratorsByCountry = async ({
  institutionId,
  country,
  keyword = [],
  page = 0,
  rowsPerPage = 10,
  timeFilter,
  getAll = false,
}) => {
  const axios = AxiosConfigExplore();
  const searchParams = new URLSearchParams();
  searchParams.append("institutionId", institutionId);
  searchParams.append("country", country);
  keyword?.forEach((e) => searchParams.append("keyword", e));
  searchParams.append("page", page);
  searchParams.append("rowsPerPage", rowsPerPage);
  searchParams.append("getAll", getAll);
  if (timeFilter) {
    searchParams.append("timeFilter", timeFilter);
  }
  const url = `/institution/international_collaborators/details?${searchParams.toString()}`;
  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};
